<template>
    <div id="vip_price">
        <!-- 支付 -->
        <div class="vip_price3" v-if="getUserTypeImg({ vipType: userVipType }).name === '永久会员'">
            <img src="../assets/image/vip_bg11.png" alt="" width="446" height="128">
        </div>
        <div class="vip_price2"
            v-if="Object.keys(vipItem).length > 0 && getUserTypeImg({ vipType: userVipType }).name !== '永久会员'">
            <div class="vip_price2_1" style="position: relative;">
                <div class="loading-qrcode" v-if="!qrcode"
                    :style="{ background: isShowPayBtn ? 'rgba(0,0,0,0.11)!important' : '#fff' }">
                    <img v-if="!isShowPayBtn" src="@/assets/image/loading.png" width="60" height="60" />
                    <div class="play-btn" v-if="isShowPayBtn">
                        <el-link :underline="false" style="font-size: 18px;" type="primary"
                            @click.stop="goPay">点击支付</el-link>
                    </div>
                </div>

                <img v-if="payway == 1 && qrcode" :src="qrcode" width="140" height="140">
                <iframe scrolling="no" v-if="payway == 0 && qrcode" :srcdoc="qrcode" class="iframe"></iframe>
            </div>
            <div class="vip_price2_8">
                <div class="flex-row">
                    <div class="vip_price2_6 t-m-r-36" v-for="(item, i) in pay" :key="i" @click="payselect(i)">
                        <img width="12" height="12"
                            :src="payway == i ? require('@/assets/image/vip/rideo.png') : require('@/assets/image/vip/rideo1.png')"
                            alt="">
                        <img :width="item.w" :height="item.h" :src="item.img" class="t-m-l-6" />
                        <span class="t-m-l-6">{{ item.name }}</span>
                    </div>
                </div>

                <div class="vip_price2_3">￥{{ vipItem.price }}<span class="t-m-l-5" style="color: #71524A;">{{
                    `约￥${vipItem.dayPrice}/天` }}</span>
                    <!-- <span>/终身</span> -->
                </div>
                <div class="vip_price2_4">支付即视为您同意<span><a
                            href="https://api.esrke.com/rest/novel/public/protocol?type=hyxy&platform=pc"
                            target="_blank">《会员服务协议》</a></span> </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/api/api';
import data from '@/assets/data';
import QRCode from 'qrcode'
import { sendConvertData } from '@/utils/baidu'
export default {
    props: {
        userVipType: {
            type: String,
            default: ""
        },
        // 会员套餐下标
        priceIndex: {
            type: Number,
            default: -1
        },
        vipItem: {
            type: Object,
            default() {
                return {}
            }
        }
    },
    watch: {
        'vipItem': {
            handler(newVal) {
                if (newVal) {
                    if (this.getUserTypeImg({ vipType: this.userVipType }).name === '永久会员') return
                    this.qrcode = ''
                    this.isShowPayBtn = true
                    this.clear()
                    // this.getPay()
                }
            },
            deep: true,
        }
    },
    data() {
        return {
            pay: data.pay, //支付方式
            payway: 0, //支付方式下标 0支付宝 1微信
            qrcode: null,
            status: 0,
            tradeNo: '',
            interval: null, //查询订单结果
            isShowPayBtn: true, //默认true显示点击支付按钮，false表示出现二维码
        };
    },
    mounted() {

    },
    beforeDestroy() {
        this.clear()
    },
    methods: {
        getPay() {
            console.log('interval=', this.interval)
            this.qrcode = null
            this.tradeNo = ''
            this.interval = null
            const params = {
                payType: this.payway == 0 ? 'zfb' : 'wx',
                vipType: this.vipItem.type
            }
            api.getPay(params).then((res) => {
                if (res.code === 200) {
                    this.tradeNo = res.data.tradeNo
                    if ('wx' == params.payType) {
                        this.createQR(res.data.codeUrl)
                    } else if ('zfb' == params.payType) {
                        this.qrcode = res.data.zfbParam
                    }
                    this.clear()
                    if (!this.interval) {
                        this.interval = setInterval(() => {
                            api.payStatus(this.tradeNo).then((r) => {
                                if (r.code === 200) {
                                    this.status = r.data
                                    // TODO 支付结果处理
                                    if (-1 == r.data) {
                                        this.clear()
                                        this.$message({
                                            message: '已失效',
                                            type: 'warning',
                                            duration: 3000
                                        })
                                        location.reload();
                                    } else if (1 == r.data) {
                                        this.clear()
                                        this.$message({
                                            message: '支付成功',
                                            type: 'success',
                                            duration: 3000
                                        })
                                        const conversionTypes = {
                                            logidUrl: localStorage.getItem('logidUrl'),
                                            newType: 26,
                                            deviceType: 2
                                        }
                                        sendConvertData(conversionTypes).then(res => {
                                            console.log('调用转化成功=', res)
                                            // localStorage.setItem('支付成功=',res)
                                            location.reload();
                                        }).catch((err) => {
                                            // localStorage.setItem('支付失败=',err)
                                            console.log('调用转化失败=', err)
                                        })
                                        
                                    } else if (2 == r.data) {
                                        this.clear()
                                        this.$message({
                                            message: '已取消',
                                            type: 'error',
                                            duration: 3000
                                        })
                                        location.reload();
                                    }

                                } else {
                                    this.clear()
                                    this.$message.warning(res.msg)
                                }
                            })
                        }, 1000)
                    }
                }
            }).finally(() => {

            })
        },
        goPay() {
            this.isShowPayBtn = false
            this.getPay()
        },
        createQR(codeUrl) {
            let opts = {
                errorCorrectionLevel: "H",//容错级别type:"image/png",//生成的二维码类型
                quality: 0.3,//二维码质量
            }
            QRCode.toDataURL(codeUrl, opts, (er, url) => {
                this.qrcode = url
            })
        },
        clear() {
            // 清除定时器
            if (this.interval) {
                clearInterval(this.interval)
                this.interval = null
            }
        },
        //支付方式选择
        payselect(i) {
            this.isShowPayBtn = true
            this.qrcode = ''
            this.clear()
            this.payway = i
            // this.getPay()
        }
    },

};
</script>

<style lang="scss">
#vip_price {
    flex: 1;
    margin: 0 15px;
}

.qrcode {
    width: 140px;
    height: 140px;

    img {
        width: 100%;
        height: 100%;
        display: block;
    }
}

.vip_price {
    display: flex;
}

.vip_price_1 {
    flex: 1;
    margin-right: 15px;
    display: flex;
    flex-flow: column;
    align-items: center;
    justify-content: center;
    padding: 15px;
    background-color: #FFFFFF;
    border: 2px solid #FCDEA8;
    border-radius: 8px;
    padding-bottom: 45px;
    overflow: hidden;
}

.vip_price_6 {
    border: 2px solid #FF6B13;
    background-color: #FFD8AE;
}

.vip_price_1:first-child {
    flex: 1.45;
    align-items: start;
    padding-left: 23px;
    position: relative;
}

.vip_price_1:last-child {
    margin-right: 0;
}

.vip_price_2 {
    font-weight: bold;
    font-size: 21px;
    color: #030303;
    margin-bottom: 10px;
}

.vip_price_3 {
    font-weight: bold;
    font-size: 19px;
    color: #333333;
    text-decoration-line: line-through;
}

.vip_price_4 {
    font-weight: bold;
    font-size: 33px;
    color: #FF6800;
}

.vip_price_4 span {
    font-size: 17px;
}

.vip_price_5 {
    font-size: 15px;
    color: #FF1600;
}

.vip_price_7 {
    width: 100%;
    text-align: center;
    height: 35px;
    line-height: 35px;
    border-radius: 8px 8px 0 0;
    background-color: #FF2E2E;
    font-size: 17px;
    color: #FFFFFF;
    position: absolute;
    left: 0;
    bottom: 0;
}

.vip_price1 {
    margin: 20px 0;
    width: 100%;
    height: 58px;
    background: url('../assets/image/vip_bg4.png') no-repeat;
    background-size: 100% 100%;
    display: flex;
    justify-content: end;
    align-items: center;
}

.vip_price1_1 {
    font-weight: bold;
    font-size: 17px;
    color: #FF0000;
    padding-right: 40px;
}

.vip_price2 {
    display: flex;
}

.vip_price2_1 {
    width: 140px;
    height: 140px;
    box-sizing: border-box;
}

.vip_price2_2 {
    /* width: ; */
}

.vip_price2_5 {
    display: flex;
    flex-flow: column;
    justify-content: space-between;
    border-left: 1px solid #E9E9E9;
    padding: 20px 0;
    padding-left: 8px;
}

.vip_price2_6 {
    display: flex;
    align-items: center;
    font-size: 15px;
    color: #444444;
    background: none;
    cursor: pointer;
}


.vip_price2_7 {
    color: var(--tech-primary);
    font-weight: bold;
    background: #FFF2DA;
}

.vip_price2_8 {
    padding: 10px;
    display: flex;
    flex-flow: column;
    justify-content: space-between;
}

.vip_price2_2 {
    font-weight: bold;
    font-size: 21px;
    color: #FF2020;
}

.vip_price2_3 {
    font-size: 33px;
    color: #FF8719;
}

.vip_price2_3 span {
    font-size: 17px;
    color: #333333;
}

.vip_price2_4 {
    font-size: 12px;
    color: #000000;
}

.vip_price2_4 span {
    color: #FF6A01;
}

.iframe {
    border: 0;
    width: 140px;
    height: 140px;
}

.loading-qrcode {
    position: absolute;
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .play-btn {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }

    img {
        animation: rotate .5s linear infinite;
    }

}

/* 定义旋转动画 */
@keyframes rotate {
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(360deg);
    }
}
</style>